<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" @callFn="fxFlag = false" @qrsFn="subBjFn" :title="`您正在分享试卷到班级`">
			<p class="fxP">
				还没有班级？
				<span
					@click="
						goBanFn('myBanji', {
							cjFlag: 1
						})
					"
				>
					点击去创建
				</span>
			</p>
			<el-form :model="form" style="width: 430px" label-width="80px">
				<el-form-item label="选择班级">
					<el-select style="width: 100%" v-model="form.bjNum" filterable allow-create default-first-option placeholder="请选择">
						<el-option v-for="(item, index) in bjList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>
		<dialogBox :dialogFlag="delFlag" @callFn="delFlag = false" :title="''" rigTxt="确认删除" rigBg="#D33931" @qrsFn="delFn">
			<div class="delBox">
				<img src="@/assets/img/sc (6).png" alt="" />
				<h2>删除试卷后将无法恢复</h2>
				<p>是否确定删除</p>
			</div>
		</dialogBox>
		<dialogBox :dialogFlag="lsFlag" @callFn="lsFlag = false" @qrsFn="tearBtn" :title="`您正在分享试卷给老师`">
			<el-form :model="form" style="width: 430px" label-width="80px">
				<el-form-item label="手机号">
					<el-input v-model="form.phone" placeholder="输入手机号"></el-input>
				</el-form-item>
			</el-form>
		</dialogBox>
		<userHeader />
		<fuHeader :txt="a" type="2" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="timBox">
				<div class="timSx">
					<div class="zujuanSx">
						<div class="zujuanItem">
							<div class="zujuanTip zujuanTip1s">
								试卷难度
								<el-tooltip class="item" effect="dark" content="系数越小越困难，系数越大越简单" placement="top">
									<i class="el-icon-question" style="color: #9a9a9a"></i>
								</el-tooltip>
							</div>
							<div class="zujuanR">
								<el-checkbox-group v-model="sxData.nanyVal" @change="bhFn">
									<el-checkbox :label="`${(i * 0.1).toFixed(1)}`" v-for="i in 10" :key="i"></el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
						<div class="zujuanItem">
							<div class="zujuanTip zujuanTip1s">试卷模板</div>
							<div class="zujuanR">
								<el-checkbox-group v-model="sxData.yiwVal" @change="bhFn">
									<el-checkbox :label="item.templateId" v-for="(item, index) in mbData" :key="index">{{ item.template }}</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
					</div>
				</div>
				<div class="siTip">
					Q=对话，D=独白，每套模板都有共十段材料，前五段材料默认对话一文一答，即1Q，后五段材料结构略有不同。例2Q2Q3Q4Q4D结构依次为对话一文二答，对话一文二答，对话一文三答，对话一文四答，独白一文四答
				</div>
				<div class="mySjCont" v-if="!perData.length">
					<el-empty description="暂无试卷"></el-empty>
				</div>
				<div class="mySjCont" v-if="perData.length">
					<div class="mySjItem" v-for="(item, index) in perData" :key="index">
						<div class="shitiLzGding">
							<div class="shitiLzGdingT">
								{{ item.difficultyScore }}
							</div>
							<div class="shitiLzGdingB">难易度</div>
						</div>
						<div class="sjP">
							<h2>
								{{ item.title }}
								<div class="sjStatus" :class="item.status == 1 ? '' : 'sjStatusZt'">
									{{ item.status == 1 ? '试卷已生成' : item.status == 2 ? '音频合成失败' : '音频合成中' }}
								</div>
							</h2>
							<p>试卷编号：{{ item.number }}</p>
						</div>
						<div class="sjBtns">
							<div class="sjBtn" :class="item.status != 1 ? 'disBtn' : ''" @click="lookBtn(item, 1)">
								<img src="@/assets/img/chak.svg" class="img1" alt="" />
								<img src="@/assets/img/chak2.svg" class="img2" alt="" />
							</div>
							<div class="sjBtn" :class="item.status != 1 ? 'disBtn' : ''" @click="lookBtn(item, 2)">
								<img src="@/assets/img/fenx (4).svg" class="img1" alt="" />
								<img src="@/assets/img/fenx2.svg" class="img2" alt="" />
							</div>
							<div class="sjBtn" :class="item.status != 1 ? 'disBtn' : ''" @click="lookBtn(item, 3)">
								<img src="@/assets/img/fx.svg" class="img1" alt="" />
								<img src="@/assets/img/fx2.svg" class="img2" alt="" />
							</div>
							<div class="sjBtn" :class="item.status != 1 ? 'disBtn' : ''" @click="lookBtn(item, 4)">
								<i class="el-icon-download"></i>
							</div>
							<div class="sjBtn" @click="lookBtn(item, 5)">
								<img src="@/assets/img/sc.svg" class="img1" alt="" />
								<img src="@/assets/img/sc2.svg" class="img2" alt="" />
							</div>
						</div>
					</div>
					<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import fenye from '@/components/pubComponents/fenye.vue';
import dialogBox from '@/components/pubComponents/dialogBox';
import { batchDownload } from '@/assets/js/xz';

export default {
	name: 'mySj',
	data() {
		return {
			type: 1,
			txt: '',
			perData: [],
			form: {
				bjNum: [],
				phone: ''
			},
			sxData: {
				yiwVal: [],
				nanyVal: []
			},
			itemIn: '',
			bjList: [],
			fullscreenLoading: false,
			lsFlag: false,
			fxFlag: false,
			delFlag: false,
			subFlag: false,
			decFlag: false, // 试题篮子是否显示
			fullFlag: true,
			mbData: [],
			bsIns: 2,
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			a: ['个人中心']
		};
	},
	components: {
		userHeader,
		fuHeader,
		dialogBox,
		foot,
		fenye
	},
	methods: {
		bhFn() {
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		subBjFn() {
			console.log(this.form, this.itemIn, 77777);
			let set = this.$loading(this.$pre);
			this.$http
				.post(`api/app/yydBjExam/add`, {
					bjId: this.form.bjNum,
					examId: this.itemIn.groupExamId,
					type: 3
				})
				.then((res) => {
					set.close();
					if (res.code == 200) {
						this.fxFlag = false;
						this.$message({
							type: 'success',
							message: '分享成功'
						});
					}
				});
		},
		tearBtn() {
			let set = this.$loading(this.$pre);
			this.$http.get(`api/app/yydGroupQuestionExam/share/${this.itemIn.groupExamId}/${this.form.phone}`).then((res) => {
				set.close();
				if (res.code == 200) {
					this.lsFlag = false;
					this.$message({
						type: 'success',
						message: '分享成功'
					});
				}
			});
		},
		delFn() {
			let set = this.$loading(this.$pre);
			this.$http.delete(`api/app/yydGroupQuestionExam/${this.itemIn.groupExamId}`).then((res) => {
				set.close();
				if (res.code == 200) {
					this.delFlag = false;
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.perList({
						pageNum: 1,
						pageSize: 10
					});
				}
			});
		},
		async lookBtn(item, type) {
			if (item.status != 1 && type != 5) {
				return;
			}
			this.itemIn = item;
			if (type == 1) {
				this.$router.push({
					path: './timDec',
					query: {
						type: 1,
						types: 'zt',
						txt: item.title,
						groupExamId: item.groupExamId,
						crumFlag: 1,
						tabFtxt: ['首页', '我的试卷']
					}
				});
			} else if (type == 2) {
				this.fxFlag = true;
			} else if (type == 3) {
				this.form.phone = '';
				this.lsFlag = true;
			} else if (type == 4) {
				console.log('下载');
				let id = '';
				let type = '';
				id = item.groupExamId;
				type = 5;
				let arr = [];
				if (item.questionBookFileId) {
					arr.push(item.questionBookFileId);
				}
				if (item.questionAudioFileId) {
					arr.push(item.questionAudioFileId);
				}
				console.log(id, type, arr);
				// 给数组循环赋值
				this.fullscreenLoading = true;
				let newArr = arr.map(async (is, index) => {
					let res = await this.$http.get('api/app/common/getUrl', {
						params: {
							id,
							type,
							fileId: is,
							clientType: 1
						}
					}); // 年龄赋值等待
					return {
						name: res.fileName,
						url: res.msg
					};
				});
				// Promise接收一个数组
				let newArrs = await Promise.all(newArr);
				// 执行完毕，再往下走
				console.log('最终加工好的数组结果：', newArrs);
				this.fullscreenLoading = false;
				batchDownload(item.title, newArrs);
			} else if (type == 5) {
				this.delFlag = true;
			}
		},
		subjBnt() {
			this.subFlag = true;
		},
		tcFn() {
			this.subFlag = false;
		},
		lzFn() {
			this.decFlag = true;
		},
		tkFn() {
			if (this.decFlag == false) {
				this.$router.push({
					path: 'xuanzMb',
					query: {
						txt: '选择模板'
					}
				});
			} else {
				this.decFlag = false;
			}
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
		},
		goBanFn(type, qu) {
			this.fxFlag = false;
			this.$router.push({
				path: type,
				query: {
					...qu
				}
			});
		},
		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		},
		kaoBtn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './kaoshi',
				query: {
					txt: str
				}
			});
		},
		init() {
			this.$http.get(`api/app/yydBj/list`).then((res) => {
				if (res.code == 200) {
					console.log(res, 444);
					this.bjList = res.rows || [];
				}
			});
			this.$http.get('api/app/yydQuestionTypeTemplate/selectList').then((res) => {
				if (res.code == 200) {
					console.log(res, 666);
					this.mbData = res.data || [];
				}
			});
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydGroupQuestionExam/list', {
					params: {
						difficultyScores: this.sxData.nanyVal.join(','),
						templateId: this.sxData.yiwVal.join(','),
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		}
	},
	mounted() {
		const { type, txt } = this.$route.query;
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.timBox {
	width: 1200px;
	margin: 0 auto 10px;
	.timSx {
		padding: 20px 21px 2px;
		background: #ffffff;
		margin: 10px 0 0;
	}
	.siTip {
		height: 47px;
		background: #fff1f0;
		border-radius: 0px 0px 6px 6px;
		font-size: 12px;
		color: #e76a61;
		padding-left: 20px;
		line-height: 47px;
		margin-bottom: 10px;
	}
	.mySjCont {
		background: #ffffff;
		border-radius: 6px;
		padding: 0 16px;
		.mySjItem {
			padding: 21px 0;
			border-bottom: 1px solid #f8f8f8;
			display: flex;
			&:last-of-type {
				border-bottom: none;
			}
			.sjP {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				padding: 3px 0;
				h2 {
					font-size: 16px;
					color: #000000;
					font-weight: bold;
					display: flex;
					.sjStatus {
						padding: 0 6px;
						height: 24px;
						background: #e8f1eb;
						border-radius: 4px;
						font-weight: 400;
						font-size: 14px;
						color: #1d7b3a;
						line-height: 24px;
						text-align: center;
						margin-left: 15px;
					}
					.sjStatusZt {
						color: #fd9710;
						background: #fef4e7;
					}
				}
				p {
					color: #9d9d9d;
					font-size: 14px;
				}
			}
			.sjBtns {
				display: flex;
				align-items: center;
				.sjBtn {
					width: 42px;
					height: 42px;
					background: #ffffff;
					box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
					border: 1px solid #d8e0f0;
					margin-left: 10px;
					border-radius: 6px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					&:hover {
						background: rgba(29, 123, 58, 0.06);
						box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
						border: 1px solid #d8e0f0;
						i {
							color: #1d7b3a;
						}
						.img2 {
							display: block;
						}
						.img1 {
							display: none;
						}
					}
					i {
						font-size: 22px;
						color: #000000;
					}
					.img2 {
						display: none;
					}
				}
				.disBtn {
					cursor: no-drop;
					opacity: 0.4;
					&:hover {
						background: #ffffff;
						box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
						border: 1px solid #d8e0f0;
						i {
							color: #000;
						}
						.img2 {
							display: none;
						}
						.img1 {
							display: block;
						}
					}
				}
			}
			.shitiLzGding {
				width: 62px;
				background: #ffffff;
				box-sizing: border-box;
				margin-right: 14px;
				.shitiLzGdingT {
					height: 32px;
					font-weight: bold;
					font-size: 21px;
					color: #1d7b3a;
					border-radius: 10px 10px 0px 0px;
					border: 2px solid #1d7b3a;
					font-size: 21px;
					text-align: center;
					line-height: 32px;
					box-sizing: border-box;
				}
				.shitiLzGdingB {
					height: 31px;
					background: #1d7b3a;
					border-radius: 0px 0px 10px 10px;
					border: 2px solid #1d7b3a;
					color: #fff;
					font-size: 15px;
					text-align: center;
					line-height: 26px;
					box-sizing: border-box;
				}
			}
		}
	}

	.timBoxTit {
		display: flex;
		.timBoxTitInfo {
			flex: 1;
			margin-right: 10px;
			height: 136px;
			background: #ffffff;
			border-radius: 6px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			padding: 17px 17px 19px;
			position: relative;
			.timBoxTitInfoImg {
				width: 100px;
				height: 100px;
				margin-right: 11px;
				img {
					width: 100px;
					height: 100px;
					background: red;
					border-radius: 6px;
				}
			}
			.timBoxTitInfoCont {
				padding-right: 200px;
				flex: 1;
				.timBoxTitInfoFot {
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #8f9190;
					.timBoxTitInfoFotItem {
						margin-right: 26px;
						display: flex;
						align-items: center;
						img {
							width: 12px;
							height: 12px;
							margin-right: 7px;
						}
					}
				}
				.timBoxTitInfoSts {
					margin-top: 10px;
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #333333;
					margin-bottom: 7px;
					.timBoxTitInfoSt {
						margin-right: 21px;
						display: flex;
						align-items: center;
					}
					img {
						width: 13px;
						height: 13px;
						margin-right: 4px;
					}
				}
				.timBoxTitInfoP {
					display: flex;
					font-size: 12px;
					margin-bottom: 9px;
					&:last-of-type {
						margin-bottom: 0px;
					}
					p {
						width: 60px;
						margin-right: 18px;
					}
					span {
						margin-right: 22px;
						color: #333333;
						cursor: pointer;
					}
					.actives {
						color: #1d7b3a;
					}
					.tip {
						color: #8f9190;
					}
				}
				.timBoxTitInfoTit {
					display: flex;
					align-items: center;
					margin-bottom: 10px;
					.timBoxTitInfoZt {
						position: absolute;
						font-size: 12px;
						color: #1d7b3a;
						top: 20px;
						right: 19px;
					}
					h2 {
						color: #000000;
						font-size: 16px;
						font-weight: bold;
						margin-right: 16px;
					}
					.shouc {
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
							margin-top: 2px;
						}
						span {
							font-size: 14px;
							color: #1d7b3a;
						}
					}
				}
			}
			.timBoxTitInfoRig {
				position: absolute;
				right: 21px;
				display: flex;
				bottom: 15px;
				.timBoxTitInfoBtn {
					width: 90px;
					height: 30px;
					background: #1d7b3a;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-left: 10px;
					font-size: 14px;
					color: #ffffff;
					border-radius: 6px;
					cursor: pointer;
					img {
						width: 17px;
						height: 17px;
						margin-right: 3px;
					}
				}
				.timBoxTitInfoBtn1 {
					background: #ffac3e;
				}
			}
		}
		.timBoxEw {
			width: 310px;
			height: 136px;
			background: #ffffff;
			border-radius: 6px;
			.timBoxEwTit {
				margin: 17px 0 25px;
				font-size: 18px;
				color: #000000;
				font-weight: bold;
				text-align: center;
			}
			.timBoxEwCont {
				display: flex;
				padding: 0 35px;
				justify-content: space-between;
				.timBoxEwItem {
					display: flex;
					flex-direction: column;
					align-items: center;
					h2 {
						margin-bottom: 10px;
						font-weight: bold;
						font-size: 22px;
						color: #000000;
					}
					p {
						font-size: 14px;
						color: #000000;
					}
				}
				.timBoxEwItem1 {
					h2,
					p {
						color: #23a14c;
					}
				}
				.timBoxEwItem2 {
					h2,
					p {
						color: #ee5923;
					}
				}
			}
		}
	}
}
.zujuanSx {
	.zujuanItem {
		font-size: 14px;
		color: #000000;
		display: flex;
		margin-bottom: 10px;
		.zujuanBtns {
			display: flex;
			justify-content: end;
			flex: 1;
			.zujuanBtn {
				width: 88px;
				height: 40px;
				background: #ffffff;
				box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
				border: 1px solid #d8e0f0;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				color: #000000;
				margin-left: 25px;
				box-sizing: border-box;
				border-radius: 6px;
				cursor: pointer;
			}
			.zujuanBtn1 {
				background: #1d7b3a;
				color: #fff;
				border: none;
			}
		}
		.zujuanTip {
			width: 96px;
			display: flex;
			color: #9a9a9a;
			align-items: center;
			i {
				margin-left: 4px;
				margin-top: 4px;
				cursor: pointer;
			}
		}
		.zujuanTip1s {
			letter-spacing: 1px;
			i {
				margin-left: 2px;
			}
		}
		.zujuanTip2s {
			letter-spacing: 15px;
			i {
				margin-left: -11px;
			}
		}
		.zujuanR {
			display: flex;
			flex: 1;
			p {
				margin-right: 40px;
				cursor: pointer;
			}
			.myradios {
				display: flex;
				margin: 0 51px 0 12px;
				color: #000000;
				font-size: 12px;
			}
		}
	}
}
.fxP {
	margin: 0 auto 33px;
	text-align: center;
	font-size: 14px;
	color: #000000;
	span {
		color: #1d7b3a;
		cursor: pointer;
	}
}
.delBox {
	text-align: center;
	img {
		width: 70px;
		height: 70px;
		margin-bottom: 39px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9d9d9d;
		font-size: 16px;
	}
}
</style>
